<template>
  <NuxtLink :to="assembleDetailPagePath(card.productCode)" class="trouble-card-item">
    <div class="trouble-card_icon" :class="`icon${card.icon}`">
      <img :src="`/image/trouble-card_icon${card.icon}.png`" alt="" />
    </div>
    <!-- eslint-disable-next-line vue/no-v-html -- 定数リテラルの `<br>` のみ。外部入力は通さない -->
    <div class="trouble-card_text" v-html="card.text"></div>
  </NuxtLink>
</template>

<script setup lang="ts">
/**
 * お悩みカード1枚（支給の `trouble-card-item`）。
 *
 * **トップ（`organisms/index/trouble.vue`）と `/trouble` の両方で出る。** 支給は
 * `index.html` と `trouble/index.html` で同じマークアップを使っているので、部品にして
 * 2箇所に同じものを書かない（決定#5）。
 *
 * `icon` の連番はアイコン画像のファイル名と `trouble-card_icon` の修飾クラス
 * （サイズの個別調整）を兼ねる。飛び先は商品詳細なので商品コードから組む。
 *
 * **文言の `<br>` は定数が持つ。** 支給はトップと `/trouble` で3件だけ改行位置を変えているが、
 * **文言は15件とも同一**なので定数は1つにする（→ `consts/TroubleConst.ts` の注記）。
 *
 * **理由は「カード幅が違うから」ではない。** `.trouble-card` のカラム定義は
 * `renewal/style.css:1448` の1箇所だけ（3カラム／1150px 以下と 768px 以下で2カラム）で
 * トップ用の上書きが無く、支給ではどちらも `col2-main-wrapper`(816px) の中なので
 * **カード幅は 261.3px で同一**。つまり**支給側の不統一**。
 * トップ側の改行に寄せ（案b）、`DESIGN-FEEDBACK.md` #70 に記録した。
 * **SP（768px 以下）では該当3件が支給より1行多く折り返す**が、`min-height` があるので
 * 枠からのはみ出しは起きない。
 */
import type { TroubleCard } from '@/types/domains/TroubleType';
import { assembleDetailPagePath } from '@/utils/StringHelper';

type Props = {
  card: TroubleCard;
};

defineProps<Props>();
</script>
